const TABLE_ID_SEPARATOR = '__';

export const buildFullTableId = (prefix: string, uniqueId?: string): string => {
	return uniqueId ? `${prefix}${TABLE_ID_SEPARATOR}${uniqueId}` : prefix;
};

export const getTableIdPrefix = (tableId: string): string => tableId.split(TABLE_ID_SEPARATOR)[0];
